<script lang="ts" setup>
  import { useRoute } from 'vue-router';
  import { computed, onMounted } from 'vue';
  import ToastContainer from '~/components/toasts/ToastContainer.vue';
  import useNotifications from '~/stores/notifications';
  import LoadingScreen from './views/LoadingScreen.vue';
  import AppLayoutVue from './views/AppLayout.vue';
  import useAuthStore from './stores/auth';
  import useApiStatus from '~/stores/api-status';
  import MaintenanceMode from '~/views/MaintenanceMode.vue';

  const authStore = useAuthStore();
  const route = useRoute();
  const { maintenanceModeActive, ...apiStatus } = useApiStatus();

  const authenticated = computed(() => {
    return authStore.authenticated;
  });

  onMounted(async () => {
    useNotifications();
    await apiStatus.init();
  });

  function shouldUseAppLayout(): boolean {
    return !route.meta.customLayout;
  }
</script>

<template>
  <RouterView v-slot="{ Component: RouteComponent }">
    <Suspense>
      <template #default>
        <template v-if="maintenanceModeActive">
          <MaintenanceMode />
        </template>

        <template v-else-if="authenticated && shouldUseAppLayout()">
          <AppLayoutVue>
            <Component :is="RouteComponent" />
          </AppLayoutVue>
        </template>

        <template v-else>
          <Component :is="RouteComponent" />
        </template>
      </template>

      <template #fallback>
        <template v-if="authenticated && shouldUseAppLayout()">
          <AppLayoutVue>
            <LoadingScreen />
          </AppLayoutVue>
        </template>

        <template v-else>
          <LoadingScreen />
        </template>
      </template>
    </Suspense>
  </RouterView>

  <ToastContainer />
</template>